// extracted by mini-css-extract-plugin
module.exports = {"collapsible":"_3nSlwu68_0Ul_CrTPpir_b","title":"_82dLIC-8fFAB38YKWBHW6","body":"bIpkgjW_0LespMWM1f_fB"};